import {
  MdAddCircle,
  MdExitToApp,
  MdInventory,
  MdViewInAr,
  MdPeople,
  MdArrowBack,
  MdChevronRight,
  MdMenu,
  MdAccountCircle,
  MdVisibility,
  MdVisibilityOff,
} from "react-icons/md";

export const AddCircleIcon = MdAddCircle;
export const LogoutIcon = MdExitToApp;
export const PackageIcon = MdInventory;
export const ProductIcon = MdViewInAr;
export const UserIcon = MdPeople;
export const BackIcon = MdArrowBack;
export const ChevronRightIcon = MdChevronRight;
export const MenuIcon = MdMenu;
export const UserMenuIcon = MdAccountCircle;
export const Menu = MdMenu;
export const PasswordActive = MdVisibility;
export const PasswordInactive = MdVisibilityOff;
